import { create } from "zustand";
import {
  ProCard,
  ProForm,
  ProFormDatePicker,
} from "@ant-design/pro-components";
import { notification, Space } from "antd";
import React, { useState } from "react";
import { postRequest } from "../../services/EndPointApiService";
import ApplicationStore from "../../store/ApplicationStore";
import ListViewV2 from "./DataListV2";
import DataListStore from "store/DataListStore";

const resiTrackingStore = create(DataListStore);

const ProcessShopee = () => {
  const userAuth = ApplicationStore((state) => state.userAuth);
  const [reloader, setReloader] = useState(false);
  return (
    <ProCard
      bordered
      title={
        <Space>
          <i className="icofont-license icofont-2x"></i>
          <h3>Process Barang Shopee</h3>
        </Space>
      }
    >
      <ProForm
        title="Proses Barang Shopee"
        onFinish={async (values) => {
          if (userAuth.allowProcess) {
            await postRequest("process/shopee", {
              name: userAuth.firstName,
              ...values,
            });
            notification.success({
              message: "Success",
              description: "Proccess successfully started.",
            });
            setReloader(!reloader);
          } else {
            notification.error({
              message: "Process Transaction",
              description:
                "You don't have permission to do this. Please contact your administrator.",
            });
          }
        }}
      >
        <ProFormDatePicker
          width={"lg"}
          label="Tanggal Cutoff"
          name={"cutoffDate"}
          rules={[{ required: true }]}
        />
        <br />
      </ProForm>
      <br />
      <ListViewV2
        viewId="shopeeprocesslog"
        store={resiTrackingStore}
        reloader={reloader}
      />
    </ProCard>
  );
};

export default ProcessShopee;
